<script setup>
  import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
  } from "@/components/ui/alert-dialog";
  import { useToastsStore } from "@/stores/toastsStore";

  const toast = useToastsStore();

  defineProps({
    open: {
      type: Boolean,
      required: true,
    },
  });

  const emit = defineEmits(["update:open", "confirm"]);
</script>

<template>
  <AlertDialog
    :open="open"
    @update:open="emit('update:open', $event)">
    <AlertDialogContent class="font-sans">
      <AlertDialogHeader>
        <AlertDialogTitle>Do you want to proceed?</AlertDialogTitle>
        <AlertDialogDescription>You may lose your changes if you leave.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel @click="toast.info('You are still logged in')">No, stay here</AlertDialogCancel>
        <AlertDialogAction @click="emit('confirm')">Yes, log out</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
